import { RootState } from '../store';

export const gymStatusesSelector = (state: RootState) => {
  return state.gym.gymStatuses;
}

export const gymInfosSelector = (state: RootState) => {
  return state.gym.gymInfos;
}